import { ReactNode } from "react";

import {
  AutofillFailureBanner,
  ConnectionBanner,
  LanguageBanner,
  SectionButtons,
  SectionForm,
  PageWrapper,
  Page,
  Section,
} from "./section-components";
import { AutoFillStatus, TeamItem } from "../types";

export type IntakeAutoFillProps = {
  team: TeamItem;
  sidebar: boolean;
  children?: ReactNode;
  onSubmit: () => void;
  onSkip: () => void;
  submitError?: string;
  isUploading?: boolean;
  someUploaded?: boolean;
  disabled?: boolean;
  autoFillStatus?: AutoFillStatus;
  setSidebar: (sidebar: boolean) => void;
  isTeamHidden?: boolean;
  isWebEnquiry?: boolean;
  connectionError?: boolean;
  isPreview?: boolean;
  voiceConversation?: ReactNode;
  selectedLanguage?: string;
  setSelectedLanguage?: (language: string) => void;
  languageOptions?: Array<{ label: string; value: string }>;
};

export const IntakeAutoFill = ({
  team,
  sidebar,
  children,
  onSubmit,
  onSkip,
  submitError,
  isUploading,
  someUploaded,
  disabled,
  autoFillStatus,
  setSidebar,
  isTeamHidden,
  isWebEnquiry,
  connectionError,
  isPreview,
  voiceConversation,
  selectedLanguage,
  setSelectedLanguage,
  languageOptions,
}: IntakeAutoFillProps) => {
  // after failure, Next skips re-run, stale feedback would snap back to failed
  const onNext =
    someUploaded && !disabled && autoFillStatus !== "failed"
      ? onSubmit
      : onSkip;

  return (
    <PageWrapper sidebar={sidebar}>
      <LanguageBanner
        isTeamHidden={isTeamHidden}
        selectedLanguage={selectedLanguage}
      />
      {!isWebEnquiry && (
        <ConnectionBanner
          connectionError={connectionError ?? false}
          selectedLanguage={selectedLanguage}
          retry={undefined}
        />
      )}
      <AutofillFailureBanner
        autoFillFailed={autoFillStatus === "failed"}
        selectedLanguage={selectedLanguage}
      />
      <Page>
        <Section>
          <SectionForm isForm={false}>
            <SectionButtons
              isForm={false}
              team={team}
              hasError={submitError}
              onNext={onNext}
              setSidebar={setSidebar}
              disabled={{
                next:
                  autoFillStatus === "filling" ||
                  autoFillStatus === "completed" ||
                  isUploading,
              }}
              showSectionsButton
              isTeamHidden={isTeamHidden}
              isPreview={isPreview}
              voiceConversation={voiceConversation}
              selectedLanguage={selectedLanguage}
              setSelectedLanguage={setSelectedLanguage}
              languageOptions={languageOptions}
            >
              {children}
            </SectionButtons>
          </SectionForm>
        </Section>
      </Page>
    </PageWrapper>
  );
};
